export default "__VITE_ASSET__7935cceb__"